/* Aube & Elle: consent-gated journey labels for the installed Clarity integration.
 * No loader, identifiers, input values, URLs, cart interception or purchase events.
 */
(function () {
  'use strict';

  if (window.__aubeJourneyV1) return;
  var status = window.__aubeJourneyV1 = { version: '1.0.0', enabled: false };
  var parameters;
  try { parameters = new URLSearchParams(window.location.search); } catch (_) { return; }
  function excluded() {
    try {
      return window.self !== window.top || Boolean(window.Shopify && window.Shopify.designMode) || parameters.has('noanalytics');
    } catch (_) { return true; }
  }
  if (excluded()) return;

  var path = window.location.pathname;
  var pageType = path === '/' ? 'home' : /^\/products\//.test(path) ? 'product' :
    /^\/cart\/?$/.test(path) ? 'cart' : /^\/pages\//.test(path) ? 'page' :
    /^\/blogs\/[^/]+\/[^/]+/.test(path) ? 'article' : /^\/blogs\//.test(path) ? 'blog' :
    /^\/collections\//.test(path) ? 'collection' : 'other';
  var sectionRules = [
    ['product_intro', '.ap-top'], ['offer', '.ap-summary'], ['how_it_works', '.ap-ritual'],
    ['duo', '.ap-bundle-story'], ['guide', '.ap-guide'], ['faq', '.ap-faq'], ['product_final', '.ap-final'],
    ['home_intro', '.ae-hero-v3'], ['benefits', '.ae-benefits-v43'], ['mechanism', '.ae-mechanism-v412'],
    ['delivery', '.ae-services-v412'], ['home_faq', '.ae-faq-v3'], ['journal', '.ae-journal-v412'],
    ['home_final', '.ae-last-call'], ['cart_summary', '.ae-cart-summary']
  ];
  var seenSections = new Set();
  var sectionLabels = new Map();
  var dwellTimers = new Map();
  var observer = null;
  var readinessTimer = null;
  var readinessAttempts = 0;
  var highWater = 0;
  var cartViewed = false;

  // Shopify's explicit analytics choice must agree with its processing permission.
  // A missing API or an exception never grants consent.
  function consentState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.currentVisitorConsent !== 'function') return 'pending';
    try {
      var choice = privacy.currentVisitorConsent();
      return privacy.analyticsProcessingAllowed() === true && choice && choice.analytics === 'yes' ? 'yes' : 'no';
    } catch (_) { return 'no'; }
  }
  function visible() { return document.visibilityState === 'visible' && !document.hidden; }
  function permitted() {
    return status.enabled && !excluded() && visible() && consentState() === 'yes' && typeof window.clarity === 'function';
  }
  function emit(name) {
    if (!permitted()) return false;
    try { window.clarity('event', name); return true; } catch (_) { return false; }
  }
  function depth() {
    var root = document.documentElement;
    var body = document.body;
    var height = Math.max(root.scrollHeight || 0, body ? body.scrollHeight || 0 : 0);
    var viewport = window.innerHeight || root.clientHeight || 0;
    var distance = height - viewport;
    // A page that fits entirely on screen has not been scrolled.
    if (distance <= 0) return 0;
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0);
    return Math.min(100, y / distance * 100);
  }
  function onScroll() {
    if (!permitted()) return;
    var current = depth();
    for (var milestone = 10; milestone <= 100; milestone += 10) {
      if (milestone > highWater && milestone <= current) emit('scroll_' + milestone);
    }
    highWater = Math.max(highWater, current);
  }
  function closest(target, selector) {
    return target && typeof target.closest === 'function' ? target.closest(selector) : null;
  }
  function onClick(event) {
    if (!permitted() || event.defaultPrevented) return;
    var target = event.target;
    if (closest(target, '.ap [data-photo], .ap [data-gallery-prev], .ap [data-gallery-next]')) emit('gallery_interaction');
    if (closest(target, '.ap [data-choose-duo]')) emit('variant_choice_pack');
    if (closest(target, 'a[href="/pages/contact"], a[href^="mailto:"]')) emit('contact_click');
    if (closest(target, 'a[href="/checkout"], a[href="/checkout/"]')) emit('checkout_click');
  }
  function onChange(event) {
    if (!permitted()) return;
    var target = event.target;
    if (closest(target, '.ap [name^="aube-color-"]')) emit('variant_choice_color');
    else if (closest(target, '.ap [name^="aube-size-"]')) emit('variant_choice_size');
    else if (closest(target, '.ap .ap-offers input[data-pack]')) emit('variant_choice_pack');
  }
  function onToggle(event) {
    if (!permitted() || !event.target || event.target.open !== true) return;
    var target = event.target;
    if (closest(target, '.ap details#format')) emit('size_guide_open');
    else if (closest(target, '.ap-faq details, .ae-faq-v3 details')) emit('faq_open');
    else if (closest(target, '.ap details.ap-quick')) emit('product_details_open');
    else if (closest(target, '.ap-guide details')) emit('included_guide_open');
  }
  function onSubmit(event) {
    if (!permitted() || event.defaultPrevented) return;
    // The native request has not succeeded yet. This label deliberately means intent.
    // Sticky ATC uses requestSubmit(), so it takes this same path exactly once.
    if (closest(event.target, 'form.ap-form')) emit('add_to_cart_attempt');
    else if (closest(event.target, 'form.ae-cart-form') && event.submitter && event.submitter.name === 'checkout') emit('checkout_click');
  }
  function cancelDwell(element) {
    if (!dwellTimers.has(element)) return;
    window.clearTimeout(dwellTimers.get(element));
    dwellTimers.delete(element);
  }
  function stopDwell() {
    if (observer) observer.disconnect();
    observer = null;
    dwellTimers.forEach(function (timer) { window.clearTimeout(timer); });
    dwellTimers.clear();
    sectionLabels.clear();
  }
  function startDwell() {
    if (!permitted() || typeof window.IntersectionObserver !== 'function') return;
    var instance = new window.IntersectionObserver(function (entries) {
      if (observer !== instance) return;
      entries.forEach(function (entry) {
        var label = sectionLabels.get(entry.target);
        if (!permitted() || !entry.isIntersecting || entry.intersectionRatio < 0.1) {
          cancelDwell(entry.target);
          return;
        }
        if (!label || seenSections.has(label) || dwellTimers.has(entry.target)) return;
        dwellTimers.set(entry.target, window.setTimeout(function () {
          dwellTimers.delete(entry.target);
          if (!permitted() || !sectionLabels.has(entry.target)) return;
          if (emit('section_seen_' + label)) {
            seenSections.add(label);
            if (observer === instance) instance.unobserve(entry.target);
          }
        }, 1000));
      });
    }, { threshold: [0, 0.1] });
    observer = instance;
    sectionRules.forEach(function (rule) {
      if (seenSections.has(rule[0])) return;
      var element = document.querySelector(rule[1]);
      if (element) { sectionLabels.set(element, rule[0]); observer.observe(element); }
    });
  }
  function onVisibility() {
    stopDwell();
    // Hidden-tab or pre-consent movement is not replayed when tracking resumes.
    highWater = Math.max(highWater, depth());
    if (permitted()) { markCartView(); startDwell(); }
  }
  function markCartView() {
    if (pageType === 'cart' && !cartViewed && emit('cart_page_view')) cartViewed = true;
  }
  function disable() {
    status.enabled = false;
    stopDwell();
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('click', onClick);
    document.removeEventListener('change', onChange);
    document.removeEventListener('toggle', onToggle, true);
    document.removeEventListener('submit', onSubmit);
    document.removeEventListener('visibilitychange', onVisibility);
    if (readinessTimer !== null) window.clearTimeout(readinessTimer);
    readinessTimer = null;
  }
  function enable() {
    if (status.enabled) return;
    status.enabled = true;
    highWater = Math.max(highWater, depth());
    try {
      window.clarity('set', 'page_type', pageType);
      if (parameters.get('utm_source') === 'controle_codex') window.clarity('set', 'qa', 'true');
    } catch (_) { disable(); return; }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    document.addEventListener('toggle', onToggle, true);
    document.addEventListener('submit', onSubmit);
    document.addEventListener('visibilitychange', onVisibility);
    markCartView();
    startDwell();
  }
  function synchronize() {
    if (readinessTimer !== null) window.clearTimeout(readinessTimer);
    readinessTimer = null;
    var consent = consentState();
    if (excluded() || consent === 'no') { disable(); return; }
    if (consent === 'yes' && typeof window.clarity === 'function') { enable(); return; }
    disable();
    // Only wait for Shopify/Clarity availability; never queue activity for later replay.
    if (readinessAttempts++ < 60) readinessTimer = window.setTimeout(synchronize, 1000);
  }
  document.addEventListener('visitorConsentCollected', synchronize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', synchronize, { once: true });
  else synchronize();
})();
